module.exports = __webpack_public_path__ + "85967bf0d65554ee667b2e8e526bd378.svg";